import { StarGlyph } from "./Reveal";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-cream/10 bg-ink px-6 py-16 md:px-12">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 text-center">
        <div className="flex items-center gap-3">
          <img src="/assets/logo-mark.png" alt="MarStar Originals" className="h-16 w-auto" />
          <StarGlyph className="h-4 w-4" fill="#FF8A3D" />
        </div>
        <nav className="flex gap-10 font-mono text-[11px] tracking-[0.35em] text-cream/60">
          <a href="#shop" data-testid="footer-link-shop" className="transition-colors hover:text-blush">SHOP</a>
          <a href="#about" data-testid="footer-link-about" className="transition-colors hover:text-blush">ABOUT</a>
          <a href="#lookbook" data-testid="footer-link-lookbook" className="transition-colors hover:text-blush">LOOKBOOK</a>
        </nav>
        <p className="font-mono text-[10px] tracking-[0.3em] text-cream/40">
          © 2026 MARSTAR ORIGINALS — HANDMADE FOR THE SUN AND BEYOND
        </p>
      </div>
    </footer>
  );
}
